"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfActivityScheduleRuleViewModel = instanceOfActivityScheduleRuleViewModel;
exports.ActivityScheduleRuleViewModelFromJSON = ActivityScheduleRuleViewModelFromJSON;
exports.ActivityScheduleRuleViewModelFromJSONTyped = ActivityScheduleRuleViewModelFromJSONTyped;
exports.ActivityScheduleRuleViewModelToJSON = ActivityScheduleRuleViewModelToJSON;
exports.ActivityScheduleRuleViewModelToJSONTyped = ActivityScheduleRuleViewModelToJSONTyped;
const ScheduleSelection_1 = require("./ScheduleSelection");
/**
 * Check if a given object implements the ActivityScheduleRuleViewModel interface.
 */
function instanceOfActivityScheduleRuleViewModel(value) {
    return true;
}
function ActivityScheduleRuleViewModelFromJSON(json) {
    return ActivityScheduleRuleViewModelFromJSONTyped(json, false);
}
function ActivityScheduleRuleViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'aiNo': json['aiNo'] == null ? undefined : json['aiNo'],
        'dateS': json['dateS'] == null ? undefined : json['dateS'],
        'dateE': json['dateE'] == null ? undefined : json['dateE'],
        'selections': json['selections'] == null ? undefined : (json['selections'].map(ScheduleSelection_1.ScheduleSelectionFromJSON)),
    };
}
function ActivityScheduleRuleViewModelToJSON(json) {
    return ActivityScheduleRuleViewModelToJSONTyped(json, false);
}
function ActivityScheduleRuleViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'aiNo': value['aiNo'],
        'dateS': value['dateS'],
        'dateE': value['dateE'],
        'selections': value['selections'] == null ? undefined : (value['selections'].map(ScheduleSelection_1.ScheduleSelectionToJSON)),
    };
}
